export const saveAs = async (blob: Blob, title:string) => {
  const a = document.createElement('a');
  a.download = title;
  a.href = URL.createObjectURL(blob);
  a.addEventListener('click', () => {
    //give time for browser to start download then release the memory.
    setTimeout(() => URL.revokeObjectURL(a.href), 10 * 1000);
  });
  a.click();
};

export const getAudioFileExtension = (audioUrl: string): string => {
  const urlPath = new URL(audioUrl).pathname;
  const extensionMatch = urlPath.match(/\.([a-z0-9]+)(?=\?|$)/i);
  return extensionMatch ? extensionMatch[1] : 'mp3';
};
